// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { subMinutes as fn } from "../subMinutes.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const subMinutesWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default subMinutesWithOptions;
